export default {
    home: '/',
    pipelinedetail: '/pipelinedetail',
    nrwcalculate: '/nrwcalculate',
    map: '/map',
    realLoss: '/realloss',
    waterBalanceTable: '/waterbalancetable',
    signin: '/signin',
    account: '/account'
}
